import { useEffect, useRef, type RefObject } from "react"
import { findHotspotByPartNumber } from "../utils"

const SELECTED_CLASS = "hotspot--selected"

const highlight = (el: HTMLElement) => {
	el.setAttribute("opacity", "0.6")
	el.classList.add(SELECTED_CLASS)
}

const unhighlight = (el: HTMLElement) => {
	el.setAttribute("opacity", "0")
	el.classList.remove(SELECTED_CLASS)
}

export const useHotspotHighlight = (
	containerRef: RefObject<HTMLElement | null>,
	selectedPartNumber: string
) => {
	const previousPartNumberRef = useRef<string>("")

	useEffect(() => {
		const container = containerRef.current
		if (!container) return

		const previousPartNumber = previousPartNumberRef.current
		if (previousPartNumber) {
			const prev = findHotspotByPartNumber(container, previousPartNumber)
			if (prev) unhighlight(prev)
		}

		if (selectedPartNumber) {
			const current = findHotspotByPartNumber(container, selectedPartNumber)
			if (current) highlight(current)
		}

		previousPartNumberRef.current = selectedPartNumber
	}, [containerRef, selectedPartNumber])
}
